import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { urls } from '../urls'

const Home = () => <Redirect to={urls.bookings} />

export default Home
